import React from "react";
/**
 * KpiBar — a horizontal band of KPIs, used by Dashboard / Management /
 * Monitoring / Detail templates. `cols` (3 | 4 | 5) sets the desktop
 * column count; the CSS auto-collapses to 2 then 1 on narrow viewports.
 *
 * items: Array<{ label, value, delta?, testId? }>
 */
export default function KpiBar({ items = [], cols = 4, testId }) {
  return (
    <div className="tpl-kpibar" style={{ ["--kpi-cols"]: cols }} data-testid={testId || "kpi-bar"}>
      {items.map((it, i) => (
        <div key={i} className="tpl-kpi" data-testid={it.testId || `kpi-${i}`}>
          <div className="tpl-kpi__label">{it.label}</div>
          <div className="tpl-kpi__value">{it.value}</div>
          {it.delta && <div className="tpl-kpi__delta">{it.delta}</div>}
        </div>
      ))}
    </div>
  );
}
